import {yrCart} from "./cart";
import warranty from "./warranty";
import mod_regions from "./mod_regions";
import {footerMenu} from "./footer";
// import "./tooltip";

mod_regions();

window.yrCart = yrCart;

if (jQuery("#warrantywrapper").length){
  warranty.init();
}

jQuery(document).ready(footerMenu);
